import { page } from '$app/stores';
import type { SubNav } from '$lib/layout/types';
import type { Page } from '@sveltejs/kit';
import { derived, writable } from 'svelte/store';

export const headerVisible = writable(true);
export const lockHeader = writable(false);

// TODO: Add to CMS?
const subNavMap: Record<string, SubNav> = {
	'/(marketing)/gift-card': {
		type: 'anchors',
		title: 'Mill gift card',
		ctaLabel: 'Buy a gift card',
		ctaTarget: '/gift',
		entries: [
			{ name: 'What’s included', anchor: 'whats-included' },
			{ name: 'Testimonials', anchor: 'testimonials' },
			{ name: 'FAQs', anchor: 'faqs' }
		]
	}
};

export const subNav = derived(page, ({ route }: Page): SubNav | undefined => {
	if (!route?.id) return;

	return subNavMap[route.id];
});
